import { render, staticRenderFns } from "./RiasecJobRecommendations.vue?vue&type=template&id=f1144004&scoped=true&"
import script from "./RiasecJobRecommendations.vue?vue&type=script&lang=js&"
export * from "./RiasecJobRecommendations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1144004",
  null
  
)

export default component.exports